import { apiService } from "../services/api.service";

export const sestavyController = {
    GetPaletovyList,
    GetBalikStitek,
    GetGlsBalikStitek,
    GetGlsExpediciaStitky,
    GetPotvrzeniProRidice,
    GetDodaciListOdeslaniTovaru,
    GetSouhrnyDodaciList,
    GetDodaciList,
    GetVlnyVratnehoTovaru
};

function GetPaletovyList(idPaleta, onloadHandler) {
    apiService.getPdfFile("api/Sestavy/PaletovyList?paletaId=" + idPaleta, onloadHandler);
}

function GetBalikStitek(idBaliku, onloadHandler) {
    apiService.getPdfFile("api/Sestavy/BalikStitek?idBaliku=" + idBaliku, onloadHandler);
}

function GetGlsBalikStitek(idBaliku, printPosition = 1, onloadHandler, onerrorHandler) {
    apiService.getPdfFile(`api/Sestavy/GlsBalikStitek?idBaliku=${idBaliku}&printPosition=${printPosition}`, onloadHandler, onerrorHandler);
}

function GetGlsExpediciaStitky(idExpedicia, printPosition = 1, onloadHandler, onerrorHandler) {
    apiService.getPdfFile(`api/Sestavy/GlsExpediciaStitky?idExpedicia=${idExpedicia}&printPosition=${printPosition}`, onloadHandler, onerrorHandler);
}

function GetPotvrzeniProRidice(expediceId, kopie = false, onloadHandler) {
    apiService.getPdfFile(`api/Sestavy/PotvrzeniProRidice?expediceId=${expediceId}&kopie=${kopie}`, onloadHandler);
}

function GetDodaciListOdeslaniTovaru(expediceId, kopie = false, onloadHandler) {
    apiService.getPdfFile(`api/Sestavy/DodaciListOdeslaniTovaru?expediceId=${expediceId}&kopie=${kopie}`, onloadHandler);
}
function GetDodaciList(idBaliku, kopie = false, onloadHandler) {
    apiService.getPdfFile(`api/Sestavy/DodaciList?idBaliku=${idBaliku}&kopie=${kopie}`, onloadHandler);
}
function GetSouhrnyDodaciList(expediceId, kopie = false, onloadHandler) {
    apiService.getPdfFile(`api/Sestavy/SouhrnyDodaciList?expediceId=${expediceId}&kopie=${kopie}`, onloadHandler);
}
function GetVlnyVratnehoTovaru(vlnaIds, nuloveStavy, onloadHandler) {
    var vlnaIdsQueryString = `vlnaIds=${vlnaIds.join("&vlnaIds=")}`;
    apiService.getPdfFile(`api/Sestavy/VlnyVratnehoTovaru?${vlnaIdsQueryString}&nuloveStavy=${nuloveStavy}`, onloadHandler);
}



// WEBPACK FOOTER //
// ./src/controllers/sestavy.controller.js